<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-1/4 mb-2">
            <router-link
              :to="{ path: '/TransferTransactions/Create' }"
              class="vs-component vs-button bg_l_green"
              v-has-permission="permission125"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateTransferTransactions") }}
            </router-link>
          </div>
          <div class="vx-col lg:w-3/4 mb-2">
            <vs-button
              @click="uploadFile()"
              class="bg_m_green float-right"
              v-if="fileUploaded"
              :disabled="disabledBtn"
              v-has-permission="permission124"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("Submit") }}
            </vs-button>
            <label class="custom-file-upload">
              <input
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
              />

              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              {{ $t("CreateTransferTransactionsViaExcel") }}
              <span v-if="uploadedFileName" class="file-name">{{
                uploadedFileName
              }}</span>
            </label>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('OriginWarehouse'), sort: 'OriginWarehouse' },
                {
                  title: $t('DestinationWarehouse'),
                  sort: 'DestinationWarehouse',
                },
                { title: $t('RequesterName'), sort: 'RequesterName' },
                { title: $t('OperatorName'), sort: 'OperatorName' },
                {
                  title: $t('InventoryTransactionId'),
                  sort: 'InventoryTransactionId',
                },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action'), sort: 'Action' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 14%">{{ row.storeName }}</td>
                <td style="width: 14%">
                  {{ row.destinationStoreName }}
                </td>
                <td style="width: 14%">
                  {{ row.inventoryRequesterName }}
                </td>
                <td style="width: 15%">
                  {{ row.inventoryOperatorName }}
                </td>
                <td style="width: 10%; direction: ltr">
                  {{ row.inventoryTransactionId }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.persianDateTime }}
                </td>
                <td style="width: 15%">
                  <router-link
                    :to="{
                      path:
                        '/TransferTransactions/Details/' +
                        row.inventoryTransactionId,
                    }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="view-details"
                      v-has-permission="permission126"
                      >{{ $t("ViewDetails") }}</vs-button
                    >
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "warehouseManagement_TransferTransactions_Index",
  components: {
    DataGrid,
    Loading,
  },
  data() {
    return {
      permission124: "RegisterTransferByExcelFile",
      permission125: "RegisterTransfer",
      permission126: "GetTransferItems|GetTransferHeader",
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Inventory/api/TransferTransactionsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
  },
  methods: {
    ...mapActions({
      importExcel: "excel/importTransferTransactions",
    }),
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importExcel(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
      }, 1000);
    },
  },
};
</script>
